import {ProjectReopeningFormValidationSchema} from '@/features/projects/formSchemas'
import {ProjectExtended} from '@/features/projects/types'
import {zodResolver} from '@hookform/resolvers/zod'
import dayjs from 'dayjs'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const ProjectReopeningFormProvider = ({children, project}: {children: ReactNode; project: ProjectExtended}) => {
    const endDate = project.endDate || project.expirationDate

    const form = useForm({
        mode: 'onBlur',
        resolver: zodResolver(ProjectReopeningFormValidationSchema),
        defaultValues: {
            id: project.id,
            patient: {
                id: project.patient?.id,
                fullName: project.patient?.fullName,
                serviceType: project.patient?.serviceType
            },
            editingOperation: 'variation',
            siarProject: 'same_as_previous',
            referringProject: project,
            sector: project.sector,
            assistiveRegime: project.assistiveRegime || undefined,
            startDate: dayjs(endDate).add(1, 'day').toDate(),
            expirationDate: project.durationDays
                ? dayjs(endDate)
                      .add(project.durationDays + 1, 'day')
                      .toDate()
                : undefined,
            durationDays: project.durationDays ? project.durationDays : undefined,
            sender: project.sender || undefined,
            specialist: project.specialist || undefined
        }
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
